var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.iconClasses },
    [_c("base-icon", { staticClass: "_flex", attrs: { name: _vm.icon } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }